export function getCampaignReferrer() {
    const utmParams = window.sessionStorage.getItem("campaignData");

    if(utmParams !== null && utmParams !== "null") 
        return JSON.parse(utmParams);
    return null;
}

export function setCampaignReferrer(utmParams) {
    if(utmParams !== null && utmParams !== "null")
        window.sessionStorage.setItem("campaignData", JSON.stringify(utmParams));
}

export function getUrlParameter(name) {
    // obtem os parametros no caso de url proveniente de alguma ferramenta de divulgação 
    name = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(window.location.search);
    return results === null ? null : decodeURIComponent(results[1].replace(/\+/g, ' '));
  }